import i18nService from "@/services/i18n";

const baseLink = 'modules.budget_sum_calc.';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getBudgetText(text: string, args: any[] = []): string {
    const link = text.startsWith(baseLink) ? text : `${baseLink}${text}`;
    return i18nService.getTranslate(link, args).toString();
}